
import { Component, BaseMixins } from '@/lib';

@Component({name:"parent-view"})
export default class ParentView extends BaseMixins{
    name:string = 'ParentView';
    get tagNavList () {
      return this.$store.state.app.tagNavList
    }
    get notCacheName () {
      return [(this.$route.meta && this.$route.meta.notCache) ? this.$route.name : '']
    }
    get cacheList () {
      return ['ParentView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
    }
}
